import ContactCard from '../components/ContactCard'
import NewsCard from '../components/NewsCard'
import NewsCardReferenz from '../components/NewsCardReferenz'

// Filter Height Calculation
window.onload = () => {
  const body = document.querySelector('body')
  const animationWrap = document.querySelector('.animation-wrap') as HTMLElement
  body!.classList.add('loaded')
  if (animationWrap) {
    animationWrap.style.transform =
      'translateY(-' +
      document.getElementById('detailed-filter')?.clientHeight +
      'px)'
  }
  if (document.querySelectorAll('.dropdown-fullwidth:not(.nav-mobile-wrap)')) {
    document
      .querySelectorAll('.dropdown-fullwidth')
      .forEach((dropdown) => dropdown.classList.add('d-xxl-block'))
  }
  if (document.querySelectorAll('.nav-mobile-wrap')) {
    document
      .querySelectorAll('.nav-mobile-wrap')
      .forEach((dropdown) => dropdown.classList.add('d-block'))
  }
}

// Custom Elements
window.addEventListener('DOMContentLoaded', () => {
  window.customElements.define('contact-card', ContactCard)
  window.customElements.define('news-card', NewsCard)
  window.customElements.define('news-card-referenz', NewsCardReferenz)
})
